import React from 'react';
import styled from '@emotion/styled';
import { InputProps as $InputProps } from 'antd/lib/input';

import { Input } from '.';

import { HiddenFieldType } from '../../types/form';

type HiddenProps = {
  hiddenValue?: string;
  hiddenFieldType?: string;
};

export type InputProps = $InputProps & HiddenProps;

const HideInputWrapper = styled.div<{ isHidden: boolean }>`
  display: ${({ isHidden }) => (isHidden ? 'none' : 'block')};
`;

export default function Hidden({ hiddenValue, hiddenFieldType, ...rest }: InputProps) {
  return (
    <HideInputWrapper isHidden={hiddenFieldType !== HiddenFieldType.EVENT_ROLE}>
      <Input type="text" value={hiddenValue} {...rest} />
    </HideInputWrapper>
  );
}
